export default "__VITE_ASSET__D6zlLn2y__"